import request from '@/plugin/axios'; //分页查询

export function searchAdmins(params) {
  return request({
    url: 'admin/search',
    method: 'get',
    params: params
  });
}
export function saveAdmin(params) {
  return request({
    url: 'admin/save',
    method: 'post',
    params: params
  });
} // 修改密码

export function changePwd(params) {
  return request({
    url: 'admin/changePwd',
    method: 'post',
    params: params
  });
} // 发送验证码

export function sendEmail(params) {
  return request({
    url: 'admin/emailCode',
    method: 'post',
    params: params
  });
} // 绑定邮箱

export function bindEmail(params) {
  return request({
    url: 'admin/bindEmail',
    method: 'post',
    params: params
  });
}
export function deleteAdmin(params) {
  return request({
    url: 'admin/delete',
    method: 'post',
    params: params
  });
}
export function deleteMultiAdmins(params) {
  return request({
    url: 'admin/deleteMulti',
    method: 'post',
    params: params
  });
}